export interface CsvColumn {
  key: string;
  header: string;
}

/** A spreadsheet reads a cell starting with one of these as a formula. TAB and
 *  CR count: Excel strips them before it decides. */
const FORMULA_LEAD = /^[=+\-@\t\r]/;

/** RFC 4180 field quoting, with formula-injection hardening for strings. Only
 *  strings are prefixed: a number is never a formula, and a negative amount
 *  must stay a number. */
function cell(value: string | number | undefined): string {
  if (value === undefined) return "";
  let text = String(value);
  if (typeof value === "string" && FORMULA_LEAD.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** CSV text: a header row, then one row per entry, CRLF between lines. Vendor
 *  company names are vendor-typed text that lands in accounting's spreadsheet,
 *  hence the formula hardening above. */
export function toCsv(rows: Record<string, string | number>[], columns: CsvColumn[]): string {
  const header = columns.map((c) => cell(c.header)).join(",");
  const body = rows.map((row) => columns.map((c) => cell(row[c.key])).join(","));
  return [header, ...body].join("\r\n");
}
